const LabelTags = {
    p: "p",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    span: "span",
    div: "div",
    i: "i",
    u: "u",
    em: "em",
    mark: "mark",
    s: "s",
    strong: "strong"
};
export default Object.freeze(LabelTags);
